export type FunnelAttributionData = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  referrer_url?: string;
  landing_page?: string;
  last_touch_page?: string;
};

export function readFunnelAttribution(): FunnelAttributionData {
  if (typeof window === "undefined") return {};
  const url = new URL(window.location.href);
  return {
    utm_source:   url.searchParams.get("utm_source")   ?? undefined,
    utm_medium:   url.searchParams.get("utm_medium")   ?? undefined,
    utm_campaign: url.searchParams.get("utm_campaign") ?? undefined,
    utm_term:     url.searchParams.get("utm_term")     ?? undefined,
    utm_content:  url.searchParams.get("utm_content")  ?? undefined,
    referrer_url: typeof document !== "undefined" ? (document.referrer || undefined) : undefined,
    landing_page: url.pathname,
    last_touch_page: `${url.pathname}${url.search || ""}`,
  };
}

export async function readPostHogDistinctId(): Promise<string | undefined> {
  if (typeof window === "undefined") return undefined;
  const posthog = await import("posthog-js").then((m) => m.default).catch(() => null);
  return posthog?.get_distinct_id?.() ?? undefined;
}
